import React from "react";
import ReactDOM from "react-dom/client";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/global.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "./i18n";
import Router from "./pages/Router";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ModalsProvider } from "@mantine/modals";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
import { theme } from "./theme";

dayjs.extend(relativeTime);
dayjs.extend(calendar);

// Firebase App Check's reCAPTCHA v3 script (loaded externally, not part of
// this app's bundle - no `.startTime`/`reportAllChanges` reference exists
// anywhere in this codebase or its dependencies) occasionally throws from
// its own internal idle-time instrumentation. It's unrelated to anything
// this app does and doesn't affect functionality - silence only this exact,
// known-external error so it doesn't clutter the console; anything else
// still surfaces normally.
window.addEventListener("error", (event) => {
  if (event.message?.includes("reading 'startTime'") && event.error?.stack?.includes("reportAllChanges")) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <MantineProvider theme={theme} defaultColorScheme="dark">
    <Notifications position="top-center" zIndex={1000} limit={1} />
    <ModalsProvider modalProps={{ centered: true }}>
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    </ModalsProvider>
  </MantineProvider>
  // </React.StrictMode>
);
